import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconMinus = ({ t, className, height, width, fill }) => (
  <svg className={className} width={width} height={height} viewBox='0 0 29 4'>
    <title>{t('Minus')}</title>
    <g transform='translate(-5 -18)' fill='none' fillRule='evenodd'>
      <rect width={39} height={39} rx={5} />
      <rect fill={fill} x={5} y={18} width={29} height={4} rx={2} />
    </g>
  </svg>
)

export default Icon(IconMinus)
